/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { RestReportFilter } from './RestReportFilter';

export type RestReportViewRequest = {
    filter?: RestReportFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: RestReportViewRequest.exposeType;
}

export namespace RestReportViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
